module.exports = __webpack_public_path__ + "static/media/planeta2.febff77b.png";